import React from "react";
import InputArea from "../../../common/components/FormFields/InputArea";
import { useFormContext } from "react-hook-form";

export default function ANCNote() {
  const {
    handleSubmit,
    reset,
    formState: { errors },
    control,
    register,
    setValue,
    watch,
  } = useFormContext({
    // resolver: yupResolver(validationSchema),
    // defaultValues: defaultValues,
  });
  return (
    <div>
      <div className="flex justify-between bg-[#ECCBFC] rounded-t-md">
        <p className="text-sm font-semibold pl-2 py-2">Notes</p>
        <div className="flex my-auto"></div>
      </div>
      <div className="p-2 w-full border pb-2 border-b-[#D9D9D9] border-r-[#D9D9D9] border-l-[#D9D9D9] bg-white rounded-b-md">
        <InputArea minRows={4} control={control} label="Notes" name="Ancnote" />
      </div>
    </div>
  );
}
